export default class Router {
    constructor() {
        window.HondaRouter = this;
        this.routes = [];
        this.fallback = () => {};
        this.path = '';
        this.params = new URLSearchParams();
        this.data = {};
        this.callbacks = [];
        this.dataCallbacks = [];
        this.history = [];
        this.bind();
    }

    bind() {
        window.addEventListener('hashchange', () => this.match());
    }

    setData(key, value) {
        this.data[key] = value;
        this.dataCallbacks.forEach((cb) => cb());
    }

    addDataListener(cb) {
        this.dataCallbacks.push(cb);
    }

    addEventListener(cb) {
        this.callbacks.push(cb);
    }

    add(path, cb) {
        this.routes.push({ path, cb });
        return this;
    }

    remove(path) {
        this.routes = this.routers.filter((r) => r.path !== path);
        return this;
    }

    flush() {
        this.routes = [];
        return this;
    }

    clear() {
        this.params = new URLSearchParams();
        window.location.hash = '';
    }

    update(to) {
        const path = to || window.location.hash.split('?')[0];
        const query = this.params.toString() ? `?${ this.params.toString()}` : '';
        window.location.hash = path + query;
        this.history.push(window.location.hash);
        return this;
    }

    back() {
        const prev = this.history.pop();
        if (prev) {
            window.location.hash = prev;
        }
    }

    else(cb) {
        this.fallback = cb;
        return this;
    }

    match() {
        this.params = new URLSearchParams(window.location.hash.split('?')[1] || '');
        this.path = window.location.hash.split('?')[0];
        const route = this.routes.find((r) => this.path === `#${ r.path}`);
        route ? route.cb() : this.fallback();
        this.callbacks.forEach((cb) => cb());
        return route;
    }
}
